import { render } from "./WeatherAlerts.vue?vue&type=template&id=50f11976"
import script from "./WeatherAlerts.vue?vue&type=script&lang=js"
export * from "./WeatherAlerts.vue?vue&type=script&lang=js"

import "./WeatherAlerts.vue?vue&type=style&index=0&id=50f11976&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__